import { Table, Text } from '@pentabd/ui';
import products from '../../../ProductsList/data/product.json';
import { CreateProductBatchTableColumn } from './CreateProductBatchTableColumn';
import { useTranslation } from 'react-i18next';

const CreateProductBatchTable = () => {
  const { t } = useTranslation();
  return (
    <div className="p-0">
      <div className="mb-10">
        <Text component="h3" size="2xl">
          {t('INVENTORY_CREATE_PRODUCT_BATCH.ADDED_PRODUCT')}
        </Text>
        <Text component="p" weight="light" size="2xl" className="mt-1">
          {t('INVENTORY_CREATE_PRODUCT_BATCH.ADDED_PRODUCT_DESCRIPTION')}
        </Text>
      </div>
      <Table
        columns={CreateProductBatchTableColumn(t, products) as any}
        rows={products}
        pagination={{
          totalPage: Math.ceil(products.length / 5),
          onClick: (currentPage) => {
            console.log('page change handler');
          },
          activePage: 1,
        }}
      />
    </div>
  );
};

export default CreateProductBatchTable;
